/*
 *  Created by SGiri 02/14/2018
 */

import { Component, OnInit } from '@angular/core';
import { FormControl, Validators, FormGroup } from '@angular/forms'
import { Router } from '@angular/router';
import { DashboardService } from '~config/services/dashboard.service';
import { MatDialog } from '@angular/material';
import { InfoDialogComponent } from 'app/info-dialog/info-dialog.component';



@Component({
  selector: 'app-data-dictionary',
  templateUrl: './dataDictionary.component.html',
  styleUrls: ['./dataDictionary.component.css']
})
export class DataDictionaryComponent implements OnInit {


  form: FormGroup;
  selectedFile: File;
  successMsg: string | null = null;
  errorMsg: string | null = null; 
  dialogTitle: string = ''; 
  dialogMessage: string = ''; 
  dialogIsError: boolean = false;
  loading : boolean = false;
  uploaded: boolean = false;
  constructor(private service: DashboardService, private router: Router,private dialog: MatDialog) {
    
  }

  ngOnInit() {
    this.form = new FormGroup({
      location: new FormControl('L'),
      sort: new FormControl('-1'),
      userId: new FormControl({ value: '*', disabled: true }),

    })
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files.length > 0) {
      this.selectedFile = input.files[0];
    }
  }

  onSubmit(): void {
  if (this.selectedFile) {
    console.log('File selected:', this.selectedFile);
    this.loading = true;
    this.service.truncateAndReload(this.selectedFile).subscribe({
      next: (response: any) => {
       console.log("File Uploaded!");
       if(response.successMsg && !response.errMsg){
        this.dialogTitle = 'Success';
        this.dialogMessage = response.successMsg;
        this.dialogIsError = false;
        this.showDialog();
       }else{
        this.dialogTitle = 'Error';
        this.dialogMessage = response.errMsg || 'An error occurred while uploading!';
        this.dialogIsError = true;
        this.showDialog();
       }
        this.loading = false;
        this.selectedFile = null;
      },
      error: (error: any) => {
        console.log("Error while uploading file!");
        this.loading = false;
        this.selectedFile = null;
      }
    });
  }
}

  showDialog(): void {
  this.dialog.open(InfoDialogComponent, {
    data: {
      header: this.dialogTitle,
      message: this.dialogMessage,
      isError: this.dialogIsError
    }
  });
}


}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/bi-reporting-config/data-dictionary/dataDictionary.component.ts